var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_253)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.432 14C11.387 8.893 9.00003 7.547 9.00003 5V2H9.50003C9.63264 2 9.75982 1.94732 9.85359 1.85355C9.94735 1.75979 10 1.63261 10 1.5V0.5C10 0.367392 9.94735 0.240215 9.85359 0.146447C9.75982 0.0526784 9.63264 0 9.50003 0H4.50003C4.36742 0 4.24025 0.0526784 4.14648 0.146447C4.05271 0.240215 4.00003 0.367392 4.00003 0.5V1.5C4.00003 1.63261 4.05271 1.75979 4.14648 1.85355C4.24025 1.94732 4.36742 2 4.50003 2H5.00003V5C5.00003 7.547 2.61303 8.893 0.568031 14C-0.0829687 15.625 -1.75497 18 7.00003 18C15.755 18 14.083 15.625 13.432 14ZM11.815 15.751C11.113 15.961 9.71603 16.2 7.00003 16.2C4.28403 16.2 2.88703 15.961 2.18503 15.751C1.93603 15.677 1.83903 15.388 1.92703 15.123C2.14703 14.453 2.56203 13.295 3.33803 12.002C5.23403 8.843 7.20103 12.499 8.83803 12.499C10.475 12.499 10.026 10.938 10.662 12.002C11.2473 12.9864 11.7206 14.0333 12.073 15.123C12.161 15.388 12.064 15.676 11.815 15.751Z",
    fill: "#888585"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpIcons);
export default __webpack_public_path__ + "static/media/sp-icons.105173b961615da75b29693f69e8b9e3.svg";
export { ForwardRef as ReactComponent };